/**
 * API Key Query Hooks
 *
 * React Query hooks for fetching API key data.
 */

import { useQuery } from '@tanstack/react-query'
import { adminApiKeyService } from '@/services/admin-api-key.service'
import type { ApiKeyListItem } from '@/types/api-keys.types'

/**
 * Query keys for API key management
 *
 * Structured hierarchy:
 * - ['api-keys'] - All API key queries
 * - ['api-keys', 'list'] - List queries
 */
export const apiKeyKeys = {
  all: ['api-keys'] as const,
  lists: () => [...apiKeyKeys.all, 'list'] as const,
  list: () => [...apiKeyKeys.lists()] as const,
}

// ============================================================================
// Queries
// ============================================================================

/**
 * Get list of all API keys
 *
 * @returns Array of API key list items
 */
export function useApiKeys() {
  return useQuery<ApiKeyListItem[]>({
    queryKey: apiKeyKeys.list(),
    queryFn: () => adminApiKeyService.listApiKeys(),
    staleTime: 30_000, // 30 seconds
  })
}
